import React from 'react'
import Report from '../shared/Report'
import GlobalImports from '../shared/GlobalImports'

export default function Show(props) {
  const { appProps, report, accountsPath, tenantReportPath } = props

  let actions = []

  if (['sales-by-tenant', 'cash-register-sales', 'sales-by-tid'].includes(report.id) && report.actions) {
    if (report.adminRole !== 'data_analyst') {
      actions.push(
        {
          icon: 'fa-eye',
          url: item => `${ accountsPath }/${ item.api_uid }`,
          hide: item => !item.account && !item.terminal_id
        }
      )
    }

    actions.push(
      {
        icon: 'fa-chart-line-up',
        url: item => `${ tenantReportPath }${ item.account_uid }`,
        hide: item => !item.account && !item.terminal_id
      }
    )
  }

  return (
    <>
      <Report { ...props } actions={ actions } />
      <GlobalImports appProps={ appProps } />
    </>
  )
}